// 検索条件のプリセット種別
export enum WorkflowPresetKinds {
  Person = 1,
  Department = 2,
  All = 3,
}
